export const FETCH_DETAILS = 'sms/template/details';
export const FETCH_DETAILS_SUCCESS = 'sms/template/details_success';
export const FETCH_DETAILS_FAILED = 'sms/template/details_failed';

export const FETCH_LIST = 'sms/template/list';
export const FETCH_LIST_SUCCESS = 'sms/template/list_success';
export const FETCH_LIST_FAILED = 'sms/template/list_failed';

export const CREATE = 'sms/template/create';
export const CREATE_SUCCESS = 'sms/template/create_success';
export const CREATE_FAILED = 'sms/template/create_failed';

export const UPDATE = 'sms/template/update';
export const UPDATE_SUCCESS = 'sms/template/update_success';
export const UPDATE_FAILED = 'sms/template/update_failed';

export const DELETE = 'sms/template/detele';
export const DELETE_SUCCESS = 'sms/template/detele_success';
export const DELETE_FAILED = 'sms/template/detele_failed';

export const BULK = 'sms/template/bulk';
export const BULK_SUCCESS = 'sms/template/bulk_success';
export const BULK_FAILED = 'sms/template/bulk_failed';

export const CLEAR_DATA = 'sms/clear_data';

export type SmsAction =
  | typeof FETCH_DETAILS
  | typeof FETCH_DETAILS_FAILED
  | typeof FETCH_DETAILS_SUCCESS
  | typeof FETCH_LIST
  | typeof FETCH_LIST_FAILED
  | typeof FETCH_LIST_SUCCESS
  | typeof CREATE
  | typeof CREATE_FAILED
  | typeof CREATE_SUCCESS
  | typeof UPDATE
  | typeof UPDATE_FAILED
  | typeof UPDATE_SUCCESS
  | typeof DELETE
  | typeof DELETE_FAILED
  | typeof DELETE_SUCCESS
  | typeof BULK
  | typeof BULK_FAILED
  | typeof BULK_SUCCESS;
